var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolineeShadow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.447,
    height: 113.472,
    viewBox: "0 0 72.447 113.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7louhflz6a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 720",
    style: {
      fill: "none"
    },
    d: "M0 0h70.659v33.647H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 388"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 390"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 386"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 389"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 384",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 383"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 382",
    style: {
      clipPath: "url(#7louhflz6a)"
    },
    transform: "translate(.895 79.825)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 706",
    d: "M70.658 42.25c0 9.29-15.817 16.825-35.331 16.825S0 51.54 0 42.25s15.817-16.825 35.327-16.825S70.658 32.96 70.658 42.25",
    transform: "translate(0 -25.427)",
    style: {
      fill: "#333"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 707",
    d: "M67.42 43.433a32.985 32.985 0 1 1-32.987-32.986A32.987 32.987 0 0 1 67.42 43.433",
    transform: "translate(1.496 21.947)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 708",
    d: "M36.224 101.899a36.225 36.225 0 1 1 36.223-36.223 36.262 36.262 0 0 1-36.223 36.223m0-66.559a30.335 30.335 0 1 0 30.335 30.336 30.371 30.371 0 0 0-30.335-30.335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 709",
    d: "M43 72.451a2.356 2.356 0 0 1-2.357-2.357v-5.891a2.357 2.357 0 1 1 4.713 0v5.888a2.356 2.356 0 0 1-2.357 2.357"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 710",
    d: "M51.245 68.916a2.356 2.356 0 0 1-2.357-2.357v-5.888a2.357 2.357 0 1 1 4.713 0v5.888a2.356 2.356 0 0 1-2.357 2.357"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 711",
    d: "M31.809 41.231a2.944 2.944 0 0 1-2.946-2.946v-10.6a2.946 2.946 0 1 1 5.892 0v10.6a2.944 2.944 0 0 1-2.946 2.946"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 712",
    d: "M11.364 25.174c2.3 2.1 3.305 4.754 2.242 5.919s-3.8.412-6.1-1.69S4.2 24.65 5.265 23.484s3.8-.412 6.1 1.69",
    transform: "translate(8.615 48.182)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 713",
    d: "M11.744 28.213c2.3 2.1 3.305 4.754 2.242 5.919s-3.8.412-6.1-1.69-3.309-4.754-2.242-5.919 3.8-.412 6.1 1.69",
    transform: "translate(9.413 54.566)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 714",
    d: "M15.163 28.213c2.3 2.1 3.305 4.754 2.242 5.919s-3.8.412-6.1-1.69S8 27.689 9.064 26.523s3.8-.412 6.1 1.69",
    transform: "translate(16.596 54.566)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 715",
    d: "m6.769 5.789 11.78 20.028 12.958-21.2S25.619-.1 18.549 1.079s-11.78 2.353-11.78 4.71",
    transform: "translate(12.67 1.867)",
    style: {
      fill: "#00dd4d"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 716",
    d: "M46.515 6.292C46.515 1.647 38.462 0 31.563 0S16.611 1.647 16.611 6.292a3.677 3.677 0 0 0 .487 1.808 2.492 2.492 0 0 0 .208.524l10.917 19.494a3.827 3.827 0 0 0 3.331 1.923h.019a3.845 3.845 0 0 0 3.34-1.975l10.908-19.44a2.235 2.235 0 0 0 .211-.524 3.666 3.666 0 0 0 .484-1.811M31.563 4.713c4.8 0 8.146.868 9.616 1.578-1.47.713-4.816 1.581-9.616 1.581S23.42 7 21.954 6.292c1.47-.71 4.812-1.578 9.612-1.578m-1.042 17.872L24.58 11.972a38.4 38.4 0 0 0 6.983.614 38.251 38.251 0 0 0 6.974-.614L32.58 22.586a1.178 1.178 0 0 1-2.056 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 717",
    d: "M47.492 83.641a6.793 6.793 0 0 1-2.434-.453 7.576 7.576 0 0 1-4.536-5.119 2.356 2.356 0 0 1 4.533-1.284 2.929 2.929 0 0 0 1.687 2 2.082 2.082 0 0 0 1.91-.208c.729-.462 1.417-.9 1.417-3.774a2.355 2.355 0 1 1 4.71 0c0 3.888-1.045 6.133-3.609 7.755a6.885 6.885 0 0 1-3.678 1.083"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolineeShadow);
export default __webpack_public_path__ + "static/media/golinee_shadow.4a345112903c5c00123b58acd4b8dbcf.svg";
export { ForwardRef as ReactComponent };